import {
  CheckOutlined,
  CloudUploadOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import { Button, Form, Space, Tag, Tooltip, Upload, UploadProps } from "antd";
import Papa from "papaparse";
import { memo, useState } from "react";

interface IProps {
  csvJsonData?: string[][];
  setCsvJsonData: (csvJsonData: string[][]) => void;
  headers: string[];
  csvTemplateUrl: string;
}

const ImportCsvForm = ({
  csvJsonData,
  setCsvJsonData,
  headers,
  csvTemplateUrl,
}: IProps) => {
  const [fileName, setFileName] = useState("");
  const customRequest: UploadProps["customRequest"] = ({
    file,
    onSuccess,
    onError,
  }) => {
    const csvFile = file as File;

    try {
      Papa.parse<string[]>(csvFile, {
        complete: function (results) {
          onSuccess?.(results.data, new XMLHttpRequest());
          setCsvJsonData(results.data);
          setFileName(csvFile.name);
        },
        skipEmptyLines: true,
      });
    } catch (error) {
      onError?.(error as Error);
    }
  };

  return (
    <Form layout="vertical" requiredMark="optional">
      {!csvJsonData && (
        <Form.Item
          label="Choose your document to be uploaded"
          extra={
            <p style={{ marginTop: 10 }}>
              Need a CSV template?{" "}
              <a
                href={csvTemplateUrl}
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                Download here
              </a>
            </p>
          }
          required
        >
          <Upload.Dragger
            accept=".csv"
            multiple={false}
            maxCount={1}
            showUploadList={false}
            customRequest={customRequest}
          >
            <p className="ant-upload-drag-icon">
              <CloudUploadOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag CSV file to this area to upload
            </p>
          </Upload.Dragger>
        </Form.Item>
      )}
      {csvJsonData && (
        <div>
          <Space size="middle">
            <div>
              <PaperClipOutlined /> {fileName}
            </div>
            <Tooltip title="Upload another file instead">
              <Upload customRequest={customRequest} showUploadList={false}>
                <Button icon={<CloudUploadOutlined />} />
              </Upload>
            </Tooltip>
            <CheckOutlined style={{ color: "#52C41A", fontSize: 24 }} />
          </Space>
          <div style={{ marginTop: 10 }}>
            Columns available to be pulled from spreadsheet
            <Space wrap style={{ marginTop: 10 }}>
              {headers.map((header, index) => (
                <Tag key={index} data-cy="ad-column-tag">
                  {header}
                </Tag>
              ))}
            </Space>
          </div>
        </div>
      )}
    </Form>
  );
};

export default memo(ImportCsvForm);
